import { mergeDeep } from "@perxis-auto/shared";
import { ItemsDefinition } from "@perxis-js/perxis-client/dist/items";
const DEFAULT_FIND_PUBLISHED_OPTIONS = {
  options: {
    offset: 0,
    limit: 100
  }
};
function defaultOptionsMiddleware() {
  return async function* closedMiddleware(call, options) {
    const {
      request,
      method: { path }
    } = call;
    if (path.endsWith(ItemsDefinition.methods.findPublished.name)) {
      Object.assign(request, {
        options: mergeDeep(DEFAULT_FIND_PUBLISHED_OPTIONS, request.options || {})
      });
    }
    const response = yield* call.next(call.request, options);
    return response;
  };
}
export {
  defaultOptionsMiddleware
};
